import { useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLanguage } from "lang/Translate";
import axios from "axios";

//api
import api from "api/api";

const loadScript = src => {
	return new Promise((resolve, reject) => {
		if (document.querySelector(`script[src="${src}"]`)) return resolve();
		const script = document.createElement("script");
		script.src = src;
		script.onload = () => resolve();
		script.onerror = err => reject(err);
		document.body.appendChild(script);
	});
};

const getGoogle = () => {
	return new Promise(resolve => {
		const check = () => {
			if (window.google) resolve(window.google);
			setTimeout(check, 20);
		};

		check();
	});
};

const GoogleLogin = ({ setLoading }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const googleButton = useRef(null);
	const lang = useLanguage();
	const [buttonWidth, setButtonWidth] = useState(0);
	const [googleScriptLoaded, setGoogleScriptLoaded] = useState(0);

	const handleCredentialResponse = useCallback(
		async response => {
			if (response.error === "popup_closed_by_user") return;
			if (response.error) throw new Error(response.error);
			setLoading(true);

			try {
				const version = require("../../../package.json").version;
				const { data } = await axios.post(
					`${api}/auth/login?type=google&version=${version}`,
					{ credential: response.credential },
					{ headers: { "content-type": "application/x-www-form-urlencoded" } }
				);

				dispatch({ type: "LOGIN" });
				window.lastUsedVersion = data.lastUsedVersion;

				if (!data.hasGroup) {
					history.push("/createGroup");
					return;
				}

				if (!data.hasAirline) {
					history.push("/createAirline");
					return;
				}

				history.push("/game");
			} catch (e) {
				console.error(e);
				alert("Error!");
			} finally {
				setLoading(false);
			}
		},
		[dispatch, history, setLoading]
	);

	const renderButton = useCallback(async () => {
		const g = await getGoogle();
		g.accounts.id.renderButton(googleButton.current, {
			type: "standard",
			theme: "filled_blue",
			size: "large",
			shape: "pill",
			locale: lang === "PL" ? "pl_PL" : "en_US",
			width: buttonWidth
		});

		g.accounts.id.prompt();
	}, [buttonWidth, lang]);

	// Render button
	useEffect(() => {
		buttonWidth > 0 && googleScriptLoaded && renderButton();
	}, [buttonWidth, renderButton, googleScriptLoaded, setLoading]);

	// Loading the script and config
	useEffect(() => {
		(async () => {
			// TODO: Place this script tag inside index.html
			await loadScript("https://accounts.google.com/gsi/client");
			setGoogleScriptLoaded(true);

			const id = "331694465848-79g01ftb1lq69vcjritg2faijnos62d2.apps.googleusercontent.com";
			const g = await getGoogle();

			g.accounts.id.initialize({
				client_id: id,
				callback: handleCredentialResponse,
				itp_support: true
			});
		})();
	}, [handleCredentialResponse]);

	// Resize observer
	useEffect(() => {
		if (!googleButton.current) return;
		const btn = googleButton.current;
		const observer = new ResizeObserver(async ([button]) => {
			const size = button.contentBoxSize[0].inlineSize;
			size > 0 && setButtonWidth(button.contentBoxSize[0].inlineSize);
		});

		observer.observe(btn);
		return () => observer.unobserve(btn);
	}, []);

	return <div ref={googleButton} className="google_btn_container" />;
};

export default GoogleLogin;
